import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postPromotion } from '@arrived/api_v2';
import { Rewards } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { promotionKeyFn, promotionsKeyFn } from './rewards.keys';

export function usePostPromotionMutation(
  options?: UseMutationOptions<Rewards.Promotion, Rewards.PromotionCreationRequest>
) {
  const queryClient = useQueryClient();

  return useMutation((promotionCreationRequest) => postPromotion(promotionCreationRequest), {
    ...options,
    onSuccess: (data, variables, context) => {
      const { uuid } = data;

      queryClient.setQueryData(promotionKeyFn(uuid), data);

      queryClient.invalidateQueries(promotionsKeyFn());

      options?.onSuccess?.(data, variables, context);
    },
  });
}
